/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/** male / female / unisex (= null) */
export type Gender = 'male' | 'female' | 'unisex';

export const Gender = {
	Male: 'male' as Gender,
	Female: 'female' as Gender,
	Unisex: 'unisex' as Gender
};
